import banner from "assets/img/profile/banner.jpg";
import Card from "components/card";

const Banner = () => {
  return (
    <div className="">
    <Card extra={"items-center w-full h-full p-[16px] bg-cover"}>
      {/* Background and profile */}
      <div
        className="relative mt-1 flex h-32 w-full text-center rounded-xl bg-cover"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <div className="text-[22px] font-bold font-[font-serif]  mb-3 ml-5 text-center rtl:text-right text-shadow-lg/40 text-white mt-7 font-medium flex items-center dark:text-white">
          Why Choose Apex Learning Solutions?
        </div>
      </div>




    </Card>
    </div>
  );
};

export default Banner;
